import { Chip, useTheme } from "@mui/material";

import { TAB_LABELS } from "../dashboard/tabs/tabLabels";

const resolveLabel = (originTab) => {
  if (!originTab) {
    return "All tabs";
  }
  return TAB_LABELS[originTab] || "All tabs";
};

const TabOriginBadge = ({ originTab }) => {
  const { palette } = useTheme();
  return (
    <Chip
      size="small"
      variant="outlined"
      label={resolveLabel(originTab)}
      sx={{
        backgroundColor: palette.backgroundGray.main,
        color: palette.text.secondary,
        borderColor: palette.backgroundGray.dark,
        height: 20,
        "& .MuiChip-label": { px: 1 }
      }}
    />
  );
};

export default TabOriginBadge;
